module.exports = __webpack_public_path__ + "img/swiper3.a210984.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lifeHome/swiper3.png
// module id = 420
// module chunks = 0